import theme from '@adsk/alloy-react-theme';

export const toggleStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingTop: '16px',
};

export const toggleLabelNameStyle = {
  ...theme.typography.labelSmall,
  color: theme.colors.charcoal700,
};

export const licensesRemainingStyle = {
  fontSize: '11px',
  color: theme.colors.charcoal600,
};

export const toggleContainerStyle = {
  display: 'flex',
};
